/** A file covers at most this many days; the BFF checks it again. */
export const MAX_EXPORT_DAYS = 90;

export const EXPORT_RANGE_MESSAGE = 'Choose a range of up to 90 days to export';

const DAY_MS = 24 * 60 * 60 * 1000;

export type ExportRangeCheck =
    { readonly allowed: true } | { readonly allowed: false; readonly message: string };

/** Checked before the download, so a range too wide makes no request at all. */
export function exportRangeCheck(window: { from: string; to: string }): ExportRangeCheck {
    const span = Date.parse(window.to) - Date.parse(window.from);
    return span > MAX_EXPORT_DAYS * DAY_MS
        ? { allowed: false, message: EXPORT_RANGE_MESSAGE }
        : { allowed: true };
}
